import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';

const SocialMediaLinkItemSortable = SortableElement((props) => {
  const {
    value,
  } = props;

  return (
    <tr className="sortable-tr">
      <td><img src={value.icon} alt="" style={{width: '25px'}}/></td>
      <td className="sortable-td">{value.url}</td>
      <td className="sortable-td">
        <Glyphicon glyph="move" />
      </td>
    </tr>
  )
})

export default SocialMediaLinkItemSortable;


// WEBPACK FOOTER //
// ./src/app/screens/general/footerContent/footerContentView/socialMediaLinkItemSortable.js